/*
 * EL ESTADO DE MONITOREO SE PINTA, NO SE DEDUCE (RN-199 bis, RNF-050, RNF-053).
 *
 * Esta pieza recibe `claveEstado` —que produce el SERVIDOR— y la traduce a ícono,
 * texto y color. NO compara umbrales, NO mira el signo del disponible y NO vuelve
 * a decidir nada. La diferencia importa y es la regla, no un defecto:
 *
 *   $500.01 gastados sobre $500.00 presupuestados llegan como CERCA_DEL_LIMITE
 *   con disponible −$0.01, porque el umbral se compara sobre el avance YA
 *   REDONDEADO a dos decimales. La frontera real está en $500.03 → EXCEDIDO.
 *
 * Si esta pieza dedujera el estado del disponible negativo, esa línea saldría
 * "excedido" y contradiría al servidor.
 *
 * NUNCA SOLO COLOR (RNF-050): siempre ícono + texto + color, para que el estado se
 * lea también en escala de grises y con lector de pantalla.
 */

/** Respaldos por si el catálogo no viajara completo. El estado sigue viniendo del servidor. */
const RESPALDO = {
  DENTRO: { icono: '✓', nombre: 'Dentro del presupuesto', clase: 'ok' },
  CERCA_DEL_LIMITE: { icono: '▲', nombre: 'Cerca del límite', clase: 'w' },
  EXCEDIDO: { icono: '!', nombre: 'Excedido', clase: 'e' },
};

function claseDeColor(claveEstado, claveTokenDeColor) {
  const token = String(claveTokenDeColor ?? '').toUpperCase();
  if (token.includes('EXCEDIDO') || token.includes('ERROR') || token.includes('PELIGRO')) return 'e';
  if (token.includes('CERCA') || token.includes('ALERTA') || token.includes('AVISO')) return 'w';
  if (token.includes('DENTRO') || token.includes('OK') || token.includes('BIEN')) return 'ok';
  return RESPALDO[claveEstado]?.clase ?? '';
}

/**
 * @param claveEstado         DENTRO · CERCA_DEL_LIMITE · EXCEDIDO. Nulo = el mes o
 *                            la línea no tienen estado, y entonces se dice eso.
 * @param esProyeccion        el mes todavía no ocurre: se rotula "proyectado" y NO
 *                            se presenta como alarma (RN-198).
 */
export function EstadoDeMonitoreo({
  claveEstado,
  nombreEstado,
  iconoEstado,
  claveTokenDeColor,
  esProyeccion = false,
  textoSinEstado = 'Sin presupuesto en este mes · no hay estado',
  marca = 'estado',
}) {
  if (!claveEstado) {
    return (
      <span className="chip" data-prueba={`${marca}-sin-estado`}>
        <span aria-hidden="true">◇</span> {textoSinEstado}
      </span>
    );
  }

  const respaldo = RESPALDO[claveEstado] ?? { icono: '•', nombre: claveEstado, clase: '' };
  const icono = iconoEstado || respaldo.icono;
  const nombre = nombreEstado || respaldo.nombre;

  if (esProyeccion) {
    return (
      <span className="chip mo" data-prueba={marca} data-clave-estado={claveEstado}>
        <span aria-hidden="true">◔</span> Proyección · {nombre.toLowerCase()} (proyectado)
      </span>
    );
  }

  return (
    <span
      className={`chip ${claseDeColor(claveEstado, claveTokenDeColor)}`.trim()}
      data-prueba={marca}
      data-clave-estado={claveEstado}
    >
      <span aria-hidden="true">{icono}</span> {nombre}
    </span>
  );
}
